import { FC, useEffect, useState } from "react";
import { PeriodFilter } from "../../../common/enums/common.enums";
import { IChart, IChartInfo } from "../../../common/interfaces/chart.interface";
import { IStatistics } from "../../../common/interfaces/statistic.interface";
import SideInfo from "../../../pages/Platform/SideInfo";
import BarChart from "../../charts/BarChart";
import { useTabContext } from "../../../context/tabs/TabContext";
import { getTreasuryProfitLoss } from "../../../api/clubs/club.api";
import { convertChartData } from "../../../common/helpers/chart.helper";
import { convertStatisticData } from "../../../common/helpers/statistics.helper";

const ProfitLossChart: FC<{ clubAddress: string }> = ({ clubAddress }) => {
  const [profitLossChartInfo, setProfitLossChartInfo] = useState<IChart[]>();
  const [profitLossChartInfoStatistics, setProfitLossChartInfoStatistics] =
    useState<IStatistics>();
  const [profitLossChartTab, setProfitLossChartTab] = useState<string>(
    PeriodFilter.DAILY
  );

  useEffect(() => {
    void getProfitLossChartInfo();
  }, []);

  const getProfitLossChartInfo = async () => {
    try {
      const response: IChartInfo = await getTreasuryProfitLoss(clubAddress);
      const convertedChartData: IChart[] | undefined = convertChartData(
        response,
        "Total profit/loss"
      );
      setProfitLossChartInfo(convertedChartData);
      const statisticData = convertStatisticData(response);
      setProfitLossChartInfoStatistics(statisticData);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <useTabContext.Provider
      value={{
        tab: profitLossChartTab,
        changeTab: (tab: PeriodFilter) => setProfitLossChartTab(tab),
      }}
    >
      <SideInfo statisticsData={profitLossChartInfoStatistics} />
      <BarChart chartData={profitLossChartInfo} />
    </useTabContext.Provider>
  );
};

export default ProfitLossChart;
